import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于韩国漫画网 - 免费漫画大全平台',
    description: '韩国漫画网是专业的韩国漫画在线阅读平台，提供免费漫画大全和好看的韩国漫画推荐，采用无遮挡下拉式阅读模式。',
    url: 'https://koreanmanhwa.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩国漫画网',
      url: 'https://koreanmanhwa.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="py-6">
              <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                关于我们
              </h1>
              <p className="text-sm text-foreground-500 mt-2">了解韩国漫画网的故事与使命</p>
            </div>

            <section className="mb-12">
              <div className="flex flex-col lg:flex-row gap-8 items-center">
                <div className="lg:w-1/2">
                  <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                    <a href="#brand-intro">品牌介绍</a>
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    韩国漫画网创立于2024年，是专注于韩国漫画在线阅读的优质平台。我们致力于为中国漫画爱好者提供<strong>免费漫画大全</strong>和最优质的<strong>好看韩漫推荐</strong>服务。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    作为领先的韩国漫画阅读平台，我们深知读者对于阅读体验的追求。因此，我们创新性地推出了<strong>无遮挡下拉式阅读</strong>模式，彻底告别传统翻页式阅读的繁琐操作，让每一次在线阅读都变得舒适流畅。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    我们的团队由一群热爱漫画的年轻人组成，每天精心筛选和更新最优质的韩国漫画资源。从恋爱到奇幻，从热血到剧情，8大分类覆盖所有主流类型，满足不同读者的口味需求。
                  </p>
                </div>
                <div className="lg:w-1/2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20cozy%20reading%20space%20with%20digital%20tablet%20displaying%20colorful%20comics%2C%20warm%20ambient%20lighting%2C%20bookshelf%20background%2C%20comfortable%20atmosphere%2C%20creative%20workspace%2C%20editorial%20photography%20style%2C%20soft%20coral%20and%20cream%20tones%2C%20no%20text&width=800&height=500&seq=about-brand-01&orientation=landscape"
                    alt="韩国漫画网品牌介绍"
                    title="韩国漫画网 - 舒适的在线阅读体验"
                    className="rounded-lg w-full h-auto object-cover"
                  />
                </div>
              </div>
            </section>

            <section className="mb-12 bg-background-100 rounded-xl p-6 md:p-8">
              <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-6 text-center">
                <a href="#why-us">为什么选择我们</a>
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  {
                    icon: 'ri-book-read-line',
                    title: '海量漫画资源',
                    desc: '超过1000部韩国漫画作品，8大分类覆盖所有主流类型，每日持续更新。',
                  },
                  {
                    icon: 'ri-smartphone-line',
                    title: '无遮挡下拉式阅读',
                    desc: '专为韩漫优化的下拉式阅读模式，无广告遮挡，流畅丝滑。',
                  },
                  {
                    icon: 'ri-shield-check-line',
                    title: '完全免费',
                    desc: '所有漫画资源永久免费，无需注册付费，即点即看。',
                  },
                  {
                    icon: 'ri-heart-line',
                    title: '用户口碑',
                    desc: '数百万读者的信赖选择，好评如潮，好看的韩国漫画推荐首选平台。',
                  },
                ].map((item) => (
                  <div key={item.title} className="text-center">
                    <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className={`${item.icon} text-primary-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-6">
                <a href="#reputation">读者口碑</a>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    name: '漫画爱好者小王',
                    comment: '韩国漫画网真的是我用过最好用的韩漫阅读平台！下拉式阅读太舒服了，不用点来点去翻页，一口气看了好几话。免费漫画大全资源也很全，强烈推荐！',
                    rating: 5,
                  },
                  {
                    name: '资深漫迷Lisa',
                    comment: '找了好久才找到这么全的韩漫网站，分类特别清晰，好看韩漫推荐也很精准。最重要的是无遮挡啊，之前在其他站看总有广告跳出来，这里完全没有！',
                    rating: 5,
                  },
                  {
                    name: '新入坑的小陈',
                    comment: '朋友推荐的韩国漫画网，一开始还担心免费的质量不好，结果完全超预期！画质清晰，更新也快，在线阅读体验一流，已经成为我的每日必刷了。',
                    rating: 5,
                  },
                ].map((review) => (
                  <div key={review.name} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{review.comment}</p>
                    <p className="text-xs text-foreground-400 font-medium">{review.name}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-6">
                <a href="#contact">联系我们</a>
              </h2>
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="lg:w-1/2">
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 bg-primary-100 rounded-full flex items-center justify-center shrink-0">
                        <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                        <p className="text-sm text-foreground-500">contact@koreanmanhwa.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 bg-accent-100 rounded-full flex items-center justify-center shrink-0">
                        <i className="ri-customer-service-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">客服微信</p>
                        <p className="text-sm text-foreground-500">KoreanManhwa_CS</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 bg-secondary-100 rounded-full flex items-center justify-center shrink-0">
                        <i className="ri-time-line text-secondary-500 w-4 h-4 flex items-center justify-center"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">工作时间</p>
                        <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="lg:w-1/2">
                  <form
                    data-readdy-form="true"
                    id="contact-form"
                    className="bg-background-100 rounded-lg p-5 space-y-4"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const formEl = e.currentTarget;
                      const honeypot = (formEl.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                      if (honeypot) {
                        const msgEl = document.getElementById('contact-form-msg');
                        if (msgEl) {
                          msgEl.textContent = '提交成功，我们会尽快回复！';
                          msgEl.className = 'text-sm text-accent-500 mt-2';
                        }
                        return;
                      }
                      try {
                        const formData = new FormData(formEl);
                        formData.delete('website_alt');
                        const urlParams = new URLSearchParams();
                        formData.forEach((value, key) => {
                          urlParams.append(key, value as string);
                        });
                        const submitAddr = 'https://readdy.ai/api/form/d9pf19li2vhsdh2d3330';
                        const response = await fetch(submitAddr, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: urlParams.toString(),
                        });
                        const responseText = await response.text();
                        const msgEl = document.getElementById('contact-form-msg');
                        if (!msgEl) return;
                        if (response.ok) {
                          msgEl.textContent = '提交成功，我们会尽快回复！';
                          msgEl.className = 'text-sm text-accent-500 mt-2';
                          formEl.reset();
                        } else {
                          msgEl.textContent = '提交失败，请稍后重试。';
                          msgEl.className = 'text-sm text-red-500 mt-2';
                        }
                      } catch {
                        const msgEl = document.getElementById('contact-form-msg');
                        if (msgEl) {
                          msgEl.textContent = '提交失败，请稍后重试。';
                          msgEl.className = 'text-sm text-red-500 mt-2';
                        }
                      }
                    }}
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-lg bg-background-50 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-lg bg-background-50 focus:outline-none focus:border-primary-300 transition-colors duration-200"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">留言</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-3 py-2.5 text-sm border border-background-200 rounded-lg bg-background-50 focus:outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
                        placeholder="请输入您的留言（最多500字）"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="website_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="antispam"
                    />
                    <button
                      type="submit"
                      className="w-full bg-primary-500 text-background-50 text-sm py-2.5 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      发送留言
                    </button>
                    <p id="contact-form-msg" className="text-sm text-center"></p>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}